import { createSelector } from '@reduxjs/toolkit';
import { RootStateOrAny } from 'react-redux';
import { ImpersonationState } from './types';

export const impersonationSelector = createSelector(
  (state: RootStateOrAny) => state.impersonation,
  (state: ImpersonationState) => state,
);

// Convenience selectors for the common cases.
export const isImpersonatingSelector = createSelector(
  impersonationSelector,
  (state: ImpersonationState) => state.isImpersonating,
);

export const impersonatedUserSelector = createSelector(
  impersonationSelector,
  (state: ImpersonationState) => state.target,
);
